import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';
import { AppStatus } from '@/app/utils/constants/AppStatus';
import AccountAppUpgrade from '../account-app-upgrade/account-app-upgrade.vue';
import AccountAppEdit from '../account-app-edit/account-app-edit.vue';

export default {
  name: 'account-app',
  components: {
    AccountAppUpgrade,
    AccountAppEdit,
  },
  props: {
    pageLoading: {
      type: Boolean,
      default: false,
    },
    app: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    appStatus: AppStatus,
    upgrade: false,
    edit: false,
  }),
  computed: {
    hasUpgrade() {
      return this.app.currentSub && this.app.level === 'Base' && this.app.appName === 'TOOLKIT';
    },
    canEdit() {
      return this.app.currentSub && this.app.canEditSubQty;
    },
  },
  methods: {
    handleUpgrade() {
      this.upgrade = true;
      this.$mixpanel.track('startUpgrade', {
        currentApp: this.app.appName,
        currentLevel: this.app.level,
        accountName: this.$store.getters['account/getActiveAccount'].name,
      });
    },
    handleEdit() {
      this.edit = true;
    },
    handleCancel() {
      this.loading = true;
      API.post(`${ENDPOINTS.POST_SUBSCRIPTION}/${this.app.subscriptionID}`, {
        accountID: this.$store.getters['account/getActiveAccount'].uuid,
        cancel: true,
      })
        .then((response) => {
          this.$store.dispatch('billing/getSubscriptions');
          EventBus.$emit('addNotification', {
            title: `Cancelled Subscription - ${this.app.display}`,
            icon: 'tick',
            message: response.data.message,
          });
          this.$mixpanel.identify(this.$store.getters['auth/getCognitoID']);
          this.$mixpanel.people.set({
            toolkit_subscriber: this.app.appName === 'TOOLKIT' ? false : undefined,
            companion_subscriber: this.app.appName === 'COMPANION' ? false : undefined,
            education_bites_subscriber: this.app.appName === 'BITES' ? false : undefined,
          });
          this.$mixpanel.track('unsubscribed', {
            product: this.app.appName,
          });
          this.$emit('hasCancel');
          this.loading = false;
        })
        .catch(() => {
          EventBus.$emit('addNotification', {
            title: `Cancel Subscription - ${this.app.display}`,
            icon: 'cross',
            message: 'Unable to cancel subscription. Please try again',
          });
          this.$emit('hasCancelError');
          this.loading = false;
        });
    },
  },
};
